import React from "react";
import { useNavigate } from "react-router-dom";
import nscsLogoColor from "@/assets/images/nscs_logo_color.svg";

export default function MagicLinkSent() {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 py-12 lg:px-8">
      <div className="max-w-md w-full space-y-6 text-center">
        {/* Logo */}
        <div>
          <img
            alt="NSCS Logo"
            className="mx-auto h-10 w-auto"
            src={nscsLogoColor}
          />
        </div>

        {/* Title */}
        <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
          Check your inbox
        </h2>

        {/* Subtitle */}
        <p className="mt-2 text-sm text-gray-600">
          We&apos;ve emailed you a secure link to sign in. Please click that
          link to proceed with your login.
        </p>

        {/* Button: back to login */}
        <button
          className="mt-6 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2"
          onClick={handleBackToLogin}
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
